export default __webpack_public_path__ + "media/images/ok-c6a4566645a6714eefa3a20d1a4afef8.png";